import "./App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { GlobalFocusStyle } from "./globalFocusStyle";
import { DesignSystemGlobalStyles, InlineProcessing } from "./design-system";
import { isPublicJobsLocation } from "./utils/publicJobUrl";

const AuthenticatedApp = lazy(() => import("./AuthenticatedApp"));
const PublicJobRoutes = lazy(
  () => import("./pages/public/jobs/publicJobRoutes"),
);

function App() {
  return (
    <div className="App">
      <DesignSystemGlobalStyles />
      <GlobalFocusStyle />
      <Suspense
        fallback={<InlineProcessing role="status">Loading…</InlineProcessing>}
      >
        {isPublicJobsLocation(window.location) ? (
          <BrowserRouter>
            <PublicJobRoutes />
          </BrowserRouter>
        ) : (
          <AuthenticatedApp />
        )}
      </Suspense>
    </div>
  );
}

export default App;
